import { defineMessages } from "react-intl";

export const topNavMessages = defineMessages({
  moreActions: {
    id: "+LyCI8",
    defaultMessage: "More actions",
    description: "detail page top bar, settings menu button tooltip",
  },
});
